
import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GlobalService } from 'src/app/services/global.service';
import { IMyDrpOptions } from 'mydaterangepicker';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpService } from 'src/app/services/http.service';
import { Subscription } from 'rxjs';
import { configs } from 'src/app/configs/app.config';

@Component({
  selector: 'app-viewallcard',
  templateUrl: './viewallcard.component.html',
  styleUrls: ['./viewallcard.component.scss']
})

export class ViewallcardComponent implements OnInit {
  public errorMessage: string = "";
  public dragDropArray: Array<Object> = [];
  public totalRecord: Array<any> = [];
  public getAllCard: any;
  public cardData: Array<any> = new Array(0);
  public isResulSearched: boolean = false;
  public myDateRangePickerOptions: IMyDrpOptions = { dateFormat: 'dd/mm/yyyy'};
  public draggedIndex: number;
  public droppedIndex: number;
  public model: any = {};

  @Input() cardName: any;
  @Output() updatePosition = new EventEmitter();
  private updateCardSubscription: Subscription;
  
  ngOnDestroy() {
    this.updateCardSubscription.unsubscribe();
  }
  
  constructor(private ngxService: NgxUiLoaderService, private cd: ChangeDetectorRef, public globalService: GlobalService, private httpService: HttpService) {
    this.ngxService.start();
    this.updateCardSubscription = globalService.updateCardSourceMethod$.subscribe(
      ((params) => {
          this.valueChangeEvent(params['data']);
      })); 
    }

  allowDrop(ev, index) {
    if (this.draggedIndex != index)
      this.droppedIndex = index;
    if (this.draggedIndex != null && this.droppedIndex != null && this.draggedIndex != this.droppedIndex) {
      moveItemInArray(this.cardData, this.draggedIndex, this.droppedIndex);
      // this.utilService.swapThroughDragAndDrop.next({ previousIndex: this.draggedIndex, newIndex: this.droppedIndex });
      this.draggedIndex = null;
      this.droppedIndex = null;
    }
    const ele = Array.from(document.getElementsByClassName('card-tool-wrapper'));
    ele.forEach(element => {
      element.classList.remove('dragging');
    });
  }

  drag(ev, index) {
    var element: HTMLElement = ev.target;
    // document.getElementById('toolWrapper' + index).classList.add('dragging');
    this.droppedIndex = null;
    this.draggedIndex = index;
    // return false;
  }

  swap(prevrray, newArray, previousIndex, newIndex) {
    // console.log(prevrray,newArray,previousIndex,newIndex);

    let obj = JSON.parse(JSON.stringify(newArray[newIndex]));
    newArray[newIndex] = prevrray[previousIndex];
    prevrray[previousIndex] = obj;
    // console.log(this.dragDropArray);
    this.callAPiToSwap(obj, newArray, newIndex);
    this.cd.detectChanges();
  }


  private callAPiToSwap(obj, newArray, newIndex): void {
    this.httpService.createPutRequest(configs['api']['updateCardPosition'], {
      "cardId": obj['_id'],
      "newCardId": newArray[newIndex]['_id']
    }, this.globalService.order_id).subscribe((res) => {
      this.updatePosition.emit('yygygy');

    });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      // this.callAPiToSwap(obj, event.container.data, event.currentIndex);
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.httpService.createPutRequest(configs['api']['updateCardPosition'], {
        "cardId": event.container.data[event.currentIndex]['_id'],
        "newCardId": event.container.data[event.previousIndex]['_id']
      }, this.globalService.order_id).subscribe((res) => {
        this.updatePosition.emit('yygygy');

      });
    } else {

      this.swap(this.dragDropArray[event.previousContainer.id.substr(8, event.previousContainer.id.length)]['arr']
        , this.dragDropArray[event.container.id.substr(8, event.container.id.length)]['arr'],
        event.previousIndex,
        event.currentIndex);

    }
  }

  ngOnInit() {
    this.totalRecord = new Array(5);
  }
public unitscards:Array<object>=[];
  ngAfterViewInit() {
    this.unitscards=[];
    this.httpService.createGetRequest(configs['api']['fetchCard']+ this.globalService.order_id + '?cardType=' + this.cardName)
      .subscribe((res) => {
        this.ngxService.stop();
        if(res && res['units']){
          this.unitscards = res['units'][0];
          }
        for (let i = 0; i < res.list.length; i++) {
          this.cardData.push(res.list[i]);
        }
        this.createCustomArray(res);
      },
        (error) => {
          this.ngxService.stop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
          setTimeout(() => {
            this.errorMessage = "";
          }, 3000);
        })
  }

  private createCustomArray(res: any): void {
    this.dragDropArray = [];
    if (res && res['list'] && res['list'].length > 0) {

      let num = 5;
      for (let index = 0; index < num; index++) {
        this.dragDropArray.push({ name: 'array' + index, arr: [] });
      }

      for (let index = 0; index < res['list'].length;) {
        const element = res['list'][index];
        let val = Math.floor((index) / num);
        for (let i = 0; i < 5; i++) {
          if (res['list'][index + i])
            this.dragDropArray[i]['arr'].push(res['list'][index + i]);
        }

        index += num;

      }
    }
  }

  forPopupClose() {
    this.globalService.showTrue = true;
    document.body ? document.body.classList.remove('no-scroll') : '';
    this.globalService.showPopUp = "";

  }
  
  valueChangeEvent(event) {

    this.ngxService.start();
    this.unitscards=[];
    this.httpService.createGetRequest(configs['api']['fetchCard']+ this.globalService.order_id + '?cardType=' + this.cardName)
      .subscribe((res) => {
        this.ngxService.stop();
        if(res && res['units']){
          this.unitscards = res['units'][0];
          }
          this.cardData=res.list;
        this.createCustomArray(res);

      },
        (error) => {
          this.ngxService.stop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
        })
  }
  
  dateCheck(from, to, check) {
    if (check != undefined) {
      var fDate, lDate, cDate;
      if (check) {
        let arrStartdDate = check.split('-');
        cDate = (parseInt(this.getMonthValue(arrStartdDate[1])) + 1) + '/' + parseInt(arrStartdDate[0]) + '/' + parseInt(arrStartdDate[2].substr(2, 2));
      }
      if (from) {
        let arrStartdDate = from.split('-');
        from = parseInt(arrStartdDate[1]) + '/' + arrStartdDate[0] + '/' + parseInt(arrStartdDate[2].substr(2, 2));
      }
      if (to) {
        let arrStartdDate = to.split('-');
        to = parseInt(arrStartdDate[1]) + '/' + arrStartdDate[0] + '/' + parseInt(arrStartdDate[2].substr(2, 2));
      }

      fDate = Date.parse(from);
      lDate = Date.parse(to);
      cDate = Date.parse(cDate);

      if ((cDate <= lDate && cDate >= fDate)) {
        return true;
      }
    }
    return false;
  }

  getMonthValue(value): string {
    let m = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    for (let index = 0; index < m.length; index++) {
      const element = m[index];
      if (element == value)
        return index < 10 ? '0' + index : '' + index;
    }
  }

  filterData(event) {
    let start = event.beginDate;
    this.unitscards=[];
    let end = event.endDate;
    this.cardData = [];
    this.ngxService.start();
    this.httpService.createGetRequest(configs['api']['fetchCard']+ this.globalService.order_id + '?cardType=' + this.cardName)
      .subscribe((res) => {
        this.ngxService.stop();
        if(res && res['units']){
          this.unitscards = res['units'][0];
          }
        this.isResulSearched = true;
        for (let i = 0; i < res.list.length; i++) {
          if (i < 5)
            this.cardData.push(res.list[i]);
          else if (this.dateCheck(`${start.day}-${start.month}-${start.year}`, `${end.day}-${end.month}-${end.year}`, res.list[i].startDate)) {
            this.cardData.push(res.list[i]);
          }
        }
        setTimeout(() => {
          this.createCustomArray({ list: this.cardData });
        }, 0);
      },
        (error) => {
          this.ngxService.stop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
          setTimeout(() => {
            this.errorMessage = "";
          }, 3000);
        })
  }
}
